module.exports = __webpack_public_path__ + "img/arrow_right.f9548be3.svg";